import Vue from '../../lib/utils/vue'
import * as getters from '../../../builder/src/js/store/modules/getters'
import * as mutations from '../../../builder/src/js/store/modules/mutations'
import * as actions from '../../../builder/src/js/store/modules/actions'

import CvtRadioGroup from '../molecules/radio-group/RadioGroup'
import CvtRadioButton from '../molecules/radio-group/RadioButton'
import CvtSelect from '../molecules/Select'
import Button from '../molecules/Button'
import CvtInput from '../molecules/Input'

import { styled, VueEmotion } from '@egoist/vue-emotion'
import { mapGetters, mapState, mapActions } from '../../../builder/node_modules/vuex'
import VueI18n from 'vue-i18n'

Vue.use(VueEmotion)
Vue.use(VueI18n)

let Spacing, Radii, Border, Colors, textLineHeight, BorderStyle, textFontWeight, borderColor, backgroundColor, textFontSize, textColor, FontFamily, FontSize, FontWeight;

const getElementWrapper = () => styled('div')`
  
  ${(props) => {

    let style = ``;

    if(props.height) {
      style += `height: ${props.height};`
    }

    if(props.width) {
      style += `width: ${props.width};`
    }

    return style;
  }}
`

const getMainWrapper = () => styled('div')`
  width: 100%;
`

const getHeadingWrapper = () => styled('div')`
  width: 100%;
  border-bottom-width: ${Border.SIZE_1}px;
  border-bottom-style: solid;
  border-bottom-color: ${Colors.BASIC[200]};
`

const getHeading = () => styled('h1')`
  font-family: ${FontFamily.DEFAULT};
  font-weight: ${FontWeight.SEMI_BOLD};
  font-size: ${FontSize.FONT_SIZE_34 + FontSize.FONT_SIZE_10}px;
  margin-bottom: ${Spacing.SPACING_8}px;
`

const getSubHeading = () => styled('h3')`
  font-family: ${FontFamily.DEFAULT};
  font-size: ${FontSize.FONT_SIZE_14}px;
  margin-bottom: ${Spacing.SPACING_32 - Spacing.SPACING_2}px;
`


const getSectionWrapper = () => styled('div')`
  height: auto;
  min-height: ${Spacing.SPACING_96}px;
  margin-top: ${Spacing.SPACING_32}px;
  display: flex;
  justify-content: start;
  align-items: start;
`

const getSectionLeftHeading = () => styled('div')`
  font-size: ${FontSize.FONT_SIZE_14}px;
  font-weight: ${FontWeight.SEMI_BOLD};
  font-family: ${FontFamily.DEFAULT};
  ${textColor({ themeing: 'dark' }, 500)}
  ${textLineHeight('xl')}
  width: ${Spacing.SPACING_128 + Spacing.SPACING_64 + Spacing.SPACING_24}px;
`

const getSectionRightContentWrapper = () => styled('div')`
  width: 100%;
  padding-bottom: ${Spacing.SPACING_32}px;
  border-bottom-width: ${Border.SIZE_1}px;
  border-bottom-style: solid;
  border-bottom-color: ${Colors.BASIC[200]};

  &:last-child {
    border-bottom-width: 0px;
    padding-bottom: 0px;
  } 
`

const getSectionRightContentHeading = () => styled('div')`
  font-size: ${FontSize.FONT_SIZE_14}px;
  font-weight: ${FontWeight.REGULAR};
  font-family: ${FontFamily.DEFAULT};
  ${textColor({ themeing: 'dark' }, 400)}
  ${textLineHeight('xl')}
  margin-bottom: ${Spacing.SPACING_16}px;
`

const getSpecificOptionContentWrapper = () => styled('div')`
  width: 100%;
  margin-top: ${Spacing.SPACING_32}px; 
  padding: ${Spacing.SPACING_24}px ${Spacing.SPACING_12}px;
  border: ${Border.SIZE_1}px solid ${Colors.BASIC[200]};
  border-radius: ${4 * Border.SIZE_1}px;
`

const getSpecificOptionHeading = () => styled('div')`
  font-size: ${FontSize.FONT_SIZE_14}px;
  font-weight: ${FontWeight.REGULAR};
  font-family: ${FontFamily.DEFAULT};
  ${textColor({ themeing: 'dark' }, 400)}
  ${textLineHeight('xl')}
  margin-bottom: ${Spacing.SPACING_16}px;
`

const getSpecificOptionInnerWrapper = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: start;
`

const getSpecificOptionSelectInnerWrapper = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
`

const getSpecificOptionPlusBtnInnerWrapper = () => styled('div')`
  width: 30px;
  height: 40px;
  display: flex;
  justify-content: end;
  align-items: center;
`

const getIconButton = () => styled(Button)`
  font-family: ${FontFamily.DEFAULT};
  text-align: center;
  font-style: normal;
`

const getUrlConditionsWrapper = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
`

const getUrlConditionsHeading = () => styled('div')`
  font-size: ${FontSize.FONT_SIZE_14}px;
  font-weight: ${FontWeight.REGULAR};
  font-family: ${FontFamily.DEFAULT};
  ${textColor({ themeing: 'dark' }, 400)}
  ${textLineHeight('xl')}
  margin-bottom: ${Spacing.SPACING_18 + Spacing.SPACING_4}px;
`

const getUrlConditionsInnerContentWrapper = () => styled('div')`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 7px;
  margin-bottom: ${Spacing.SPACING_18 + Spacing.SPACING_4}px;
`

const getCvtInput = () => styled(CvtInput)``


export const CvtSapAudience = {
  name: 'CvtSapAudience',
  components: {
    CvtRadioGroup,
    CvtRadioButton,
    CvtSelect,
    CvtInput
  },
  data () {
    return {
      visitorType: 'all',
      trafficSource: 'all',
      eventConditions: 'off',
      urlConditions: 'disable',
    }
  },
  props: {
    mode: {
      type: String,
      default: 'LIGHT',
      required: false
    },
    
  },
  computed: {
    ...mapGetters ('globalTheme', {
      textFontWeight: getters.GLOBAL_STYLE_FONT_WEIGHT,
      textColor: getters.GLOBAL_STYLE_COLOR,
      borderColor: getters.GLOBAL_STYLE_BORDER_COLOR,
      backgroundColor: getters.GLOBAL_STYLE_BACKGROUND_COLOR,
      textFontSize: getters.GLOBAL_STYLE_FONT_SIZE,
      textLineHeight: getters.GLOBAL_STYLE_LINE_HEIGHT,
    }),
    ...mapState ('globalTheme', {
      Spacing: ({ globalTheme }) => globalTheme.Spacing,
      Radii: ({ globalTheme }) => globalTheme.Radii,
      Border: ({ globalTheme }) => globalTheme.Border,
      Colors: ({ globalTheme }) => globalTheme.Colors,
      FontFamily: ({ globalTheme }) => globalTheme.FontFamily,
      FontWeight: ({ globalTheme }) => globalTheme.FontWeight,
      BorderStyle: ({ globalTheme }) => globalTheme.BorderStyle,
      FontSize: ({ globalTheme }) => globalTheme.FontSize,
      FontWeight: ({ globalTheme }) => globalTheme.FontWeight,
    }),
  },
  created () {
    Spacing = this.Spacing
    Radii = this.Radii
    Border = this.Border
    Colors = this.Colors
    BorderStyle = this.BorderStyle
    FontFamily = this.FontFamily
    textFontWeight = this.textFontWeight
    borderColor = this.borderColor
    textColor = this.textColor
    backgroundColor = this.backgroundColor
    textFontSize = this.textFontSize
    textLineHeight = this.textLineHeight
    FontSize = this.FontSize
    FontWeight = this.FontWeight
  },
  methods: {
    ...mapActions ({}),
    onVisitorTypeChange(value) {
      this.visitorType = value;
    },
    onTrafficSourceChange(value) {
      this.trafficSource = value;
    },
    onEventConditionsChange(value) {
      this.eventConditions = value;
    },
    onUrlConditionsChange(value) {
      this.urlConditions = value;
    }
  },
  mounted () {
  },
  render: function (h) {

    const ElementWrapper                    = getElementWrapper()
    const MainWrapper                       = getMainWrapper()
    const HeadingWrapper                    = getHeadingWrapper()
    const Heading                           = getHeading()
    const SubHeading                        = getSubHeading()

    const SectionWrapper                    = getSectionWrapper()
    const SectionLeftHeading                = getSectionLeftHeading()
    const SectionRightContentWrapper        = getSectionRightContentWrapper()
    const SectionRightContentHeading        = getSectionRightContentHeading()

    
    const SpecificOptionContentWrapper      = getSpecificOptionContentWrapper()
    const SpecificOptionHeading             = getSpecificOptionHeading()

    const SpecificOptionInnerWrapper        = getSpecificOptionInnerWrapper()
    const SpecificOptionSelectInnerWrapper  = getSpecificOptionSelectInnerWrapper()
    const SpecificOptionPlusBtnInnerWrapper = getSpecificOptionPlusBtnInnerWrapper()

    const PlusButton                        = getIconButton();
    const MinusButton                       = getIconButton();
    const CvtInput                          = getCvtInput();


    const UrlConditionsWrapper              = getUrlConditionsWrapper();
    const UrlConditionsHeading              = getUrlConditionsHeading();
    const UrlConditionsInnerContentWrapper  = getUrlConditionsInnerContentWrapper();


    return (
      <MainWrapper>

        <HeadingWrapper>
          <Heading>Select Your Audience</Heading>
          <SubHeading>You can select specific types of audiences as: traffic source, geo, browsers, new users etc.</SubHeading>
        </HeadingWrapper>

        <SectionWrapper>
          <SectionLeftHeading>Visitor Types</SectionLeftHeading>

          <SectionRightContentWrapper>
            <SectionRightContentHeading>Which visitor types will see your campaign</SectionRightContentHeading>

            <ElementWrapper>
              <cvt-radio-group 
                theme={"LIGHT"} 
                orientation={'horizontal'} 
                initialValue={this.visitorType}
              >
                <cvt-radio-button 
                  size={"md"} 
                  value={'all'} 
                  onRadioClick={(value) => this.onVisitorTypeChange(value)}
                >
                  All visitor types
                </cvt-radio-button>
                <cvt-radio-button 
                  size={"md"} 
                  value={'specific'} 
                  onRadioClick={(value) => this.onVisitorTypeChange(value)}
                >
                  Specific visitor types
                </cvt-radio-button>

              </cvt-radio-group>
            </ElementWrapper>

            { this.visitorType === 'specific' && (
              <SpecificOptionContentWrapper>

                <SpecificOptionHeading>Select specific visitors types to target</SpecificOptionHeading>

                <SpecificOptionInnerWrapper>

                  <SpecificOptionSelectInnerWrapper>

                    <ElementWrapper
                      width={'160px'}
                    >
                      <cvt-select 
                        value={'returning-visitors'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"returning-visitors"}>Returning visitors</option>
                        <option value={"lorem-ipsum"}>Lorem Ipsum</option>
                        <option value={"dollar-sit"}>Dollar Sit</option>
                      </cvt-select>
                    </ElementWrapper>

                    <ElementWrapper
                      width={'auto'}
                    >
                      visited
                    </ElementWrapper>

                    <ElementWrapper
                      width={'100px'}
                    >
                      <cvt-select 
                        value={'equally'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"equally"}>Equally</option>
                        <option value={"lorem-ipsum"}>Lorem Ipsum</option>
                        <option value={"dollar-sit"}>Dollar Sit</option>
                      </cvt-select>
                    </ElementWrapper>

                    <ElementWrapper
                      width={'70px'}
                    >
                      <cvt-select 
                        value={'10'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"10"}>10</option>
                        <option value={"11"}>11</option>
                        <option value={"12"}>12</option>
                      </cvt-select>
                    </ElementWrapper>

                    <ElementWrapper
                      width={'70px'}
                    >
                      <cvt-select 
                        value={'5'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"5"}>5</option>
                        <option value={"6"}>6</option>
                        <option value={"7"}>7</option>
                      </cvt-select>
                    </ElementWrapper>

                    <ElementWrapper
                      width={'auto'}
                    >
                      to
                    </ElementWrapper>

                    <ElementWrapper
                      width={'70px'}
                    >
                      <cvt-select 
                        value={'10'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"10"}>10</option>
                        <option value={"11"}>11</option>
                        <option value={"12"}>12</option>
                      </cvt-select>
                    </ElementWrapper>

                    <ElementWrapper
                      width={'auto'}
                    >
                      last
                    </ElementWrapper>

                    <ElementWrapper
                      width={'70px'}
                    >
                      <cvt-select 
                        value={'1'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"1"}>1</option>
                        <option value={"2"}>2</option>
                        <option value={"3"}>3</option>
                      </cvt-select>
                    </ElementWrapper>

                    <ElementWrapper
                      width={'70px'}
                    >
                      <cvt-select 
                        value={'day'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"day"}>day</option>
                        <option value={"lorem-ipsum"}>Lorem Ipsum</option>
                        <option value={"dollar-sit"}>Dollar Sit</option>
                      </cvt-select>
                    </ElementWrapper>

                  </SpecificOptionSelectInnerWrapper>

                  <SpecificOptionPlusBtnInnerWrapper>
                    
                    <PlusButton
                      mode={this.mode.toLowerCase()}
                      color={this.mode.toLowerCase()}
                      shape={'pill'}
                      size={'sm'}
                      icon={'plus'}
                      icononly={true}
                      onClick={(event) => { } }
                    ></PlusButton>

                  </SpecificOptionPlusBtnInnerWrapper>

                </SpecificOptionInnerWrapper>

              </SpecificOptionContentWrapper>
            )}

          </SectionRightContentWrapper>

        </SectionWrapper>


        <SectionWrapper>
          <SectionLeftHeading>Traffic Sources</SectionLeftHeading>

          <SectionRightContentWrapper>
            <SectionRightContentHeading>Which kind of incoming traffic sources will see your campaign</SectionRightContentHeading>

            <ElementWrapper>
              <cvt-radio-group 
                theme={"LIGHT"} 
                orientation={'horizontal'} 
                initialValue={this.trafficSource}
              >
                <cvt-radio-button 
                  size={"md"} 
                  value={'all'} 
                  onRadioClick={(value) => this.onTrafficSourceChange(value)}
                >
                  All traffic sources
                </cvt-radio-button>
                <cvt-radio-button 
                  size={"md"} 
                  value={'specific'} 
                  onRadioClick={(value) => this.onTrafficSourceChange(value)}
                >
                  Specific traffic sources
                </cvt-radio-button>

              </cvt-radio-group>
            </ElementWrapper>

            { this.trafficSource === 'specific' && (
              <SpecificOptionContentWrapper>

                <SpecificOptionHeading>Select specific domain URLs to target</SpecificOptionHeading>

                <SpecificOptionInnerWrapper>

                  <SpecificOptionSelectInnerWrapper>

                    <ElementWrapper
                      width={'130px'}
                    >
                      <cvt-select 
                        value={'show-to'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"show-to"}>Show to</option>
                        <option value={"lorem-ipsum"}>Lorem Ipsum</option>
                        <option value={"dollar-sit"}>Dollar Sit</option>
                      </cvt-select>
                    </ElementWrapper>
                    
                    <ElementWrapper
                      width={'140px'}
                    >
                      <cvt-select 
                        value={'referral-url'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"referral-url"}>Referral URL</option>
                        <option value={"lorem-ipsum"}>Lorem Ipsum</option>
                        <option value={"dollar-sit"}>Dollar Sit</option>
                      </cvt-select>
                    </ElementWrapper>

                    <ElementWrapper
                      width={'130px'}
                    >
                      <cvt-select 
                        value={'starts-with'}
                        label={""} 
                        helpText={""}
                        multiple={false}
                        mode={'dropdown'}
                        backgroundMode={this.mode}
                        selectDisabled={false}
                        floatingLabel={true}
                        onInput={() => {}}
                      >
                        <option value={"starts-with"}>Starts with</option>
                        <option value={"lorem-ipsum"}>Lorem Ipsum</option>
                        <option value={"dollar-sit"}>Dollar Sit</option>
                      </cvt-select>
                    </ElementWrapper>

                    <ElementWrapper>
                      <CvtInput 
                        mode={this.mode} 
                        type={"url"}
                      >
                      </CvtInput>
                    </ElementWrapper>

                  </SpecificOptionSelectInnerWrapper>

                  <SpecificOptionPlusBtnInnerWrapper>
                    
                    <PlusButton
                      mode={this.mode.toLowerCase()}
                      color={this.mode.toLowerCase()}
                      shape={'pill'}
                      size={'sm'}
                      icon={'plus'}
                      icononly={true}
                      onClick={(event) => { } }
                    ></PlusButton>

                  </SpecificOptionPlusBtnInnerWrapper>

                </SpecificOptionInnerWrapper>

              </SpecificOptionContentWrapper>
            )}

          </SectionRightContentWrapper>

        </SectionWrapper>


        <SectionWrapper>
          <SectionLeftHeading>Event Conditions</SectionLeftHeading>

          <SectionRightContentWrapper>
            <SectionRightContentHeading>Select event conditions user must qualify to see your campaign</SectionRightContentHeading>
            <cvt-radio-group 
              theme={"LIGHT"} 
              orientation={'horizontal'} 
              initialValue={this.eventConditions}
            >
              <cvt-radio-button 
                size={"md"} 
                value={'off'}
                onRadioClick={(value) => this.onEventConditionsChange(value)} >
                  Off
              </cvt-radio-button>
              <cvt-radio-button 
                size={"md"} 
                value={'on'}
                onRadioClick={(value) => this.onEventConditionsChange(value)} >
                  On
              </cvt-radio-button>
            </cvt-radio-group>

          </SectionRightContentWrapper>

        </SectionWrapper>


        <SectionWrapper>
          <SectionLeftHeading>URL Conditions</SectionLeftHeading>

          <SectionRightContentWrapper>
            <SectionRightContentHeading>Select URL condition that users must pass to see your campaign</SectionRightContentHeading>
            <cvt-radio-group 
              theme={"LIGHT"} 
              orientation={'horizontal'} 
              initialValue={this.urlConditions}
            >
              <cvt-radio-button 
                size={"md"} 
                value={'disable'}
                onRadioClick={(value) => this.onUrlConditionsChange(value)} >
                  Disable
              </cvt-radio-button>
              <cvt-radio-button 
                size={"md"} 
                value={'enable'}
                onRadioClick={(value) => this.onUrlConditionsChange(value)} >
                  Enable
              </cvt-radio-button>

            </cvt-radio-group>

            { this.urlConditions === 'enable' && (
              <SpecificOptionContentWrapper>

                <UrlConditionsWrapper>

                  <UrlConditionsHeading>Show to users who</UrlConditionsHeading>
                  <UrlConditionsInnerContentWrapper>
                    <ElementWrapper
                      width={'auto'}
                    >
                      <PlusButton
                        mode={this.mode.toLowerCase()}
                        color={this.mode.toLowerCase()}
                        shape={'pill'}
                        size={'sm'}
                        icon={'plus'}
                        icononly={true}
                        onClick={(event) => { } }
                      ></PlusButton>
                    </ElementWrapper>

                    <ElementWrapper
                      width={'auto'}
                    >
                      Add show URL condition
                    </ElementWrapper>
                  </UrlConditionsInnerContentWrapper>

                </UrlConditionsWrapper>

                <UrlConditionsWrapper>

                  <UrlConditionsHeading>Exclude from users who</UrlConditionsHeading>
                  <UrlConditionsInnerContentWrapper>
                    <ElementWrapper
                      width={'auto'}
                    >
                      <PlusButton
                        mode={this.mode.toLowerCase()}
                        color={this.mode.toLowerCase()}
                        shape={'pill'}
                        size={'sm'}
                        icon={'plus'}
                        icononly={true}
                        onClick={(event) => { } }
                      ></PlusButton>
                    </ElementWrapper>

                    <ElementWrapper
                      width={'auto'}
                    >
                      Add exclude URL condition
                    </ElementWrapper>
                  </UrlConditionsInnerContentWrapper>
                  
                </UrlConditionsWrapper>

              </SpecificOptionContentWrapper>
            )}

          </SectionRightContentWrapper>

        </SectionWrapper>
        
      </MainWrapper>
    )
  }
}